export default __webpack_public_path__ + "static/media/bg.97c992af.png";